<template>
	<div class="markdown-component" :style="{height: layout.height + 'px'}">
		<!--保存代码modal-->
		<Modal v-model="save_modal.show" :footer-hide="true" title="文档保存">
			<Form :model="save_form" ref="save_form" :rules="saveValidate" :label-width="60">
				<FormItem label="标题" prop="title">
					<Input v-model="save_form.title" placeholder="请输入文档标题"/>
				</FormItem>
				<FormItem label="分类">
					<Input v-model="save_form.tag" placeholder="输入文档分类"></Input>
				</FormItem>
				<FormItem label="公开访问" :label-width="85">
					<Checkbox v-model="save_form.is_public === 1"></Checkbox>
				</FormItem>
				<FormItem>
					<Row>
						<Col span="4" offset="13">
							<Button type="primary" long @click="SaveCode">提交</Button>
						</Col>
						<Col span="4" offset="1">
							<Button type="default" long @click="CloseSaveModal">取消</Button>
						</Col>
					</Row>
				</FormItem>
			</Form>
		</Modal>
		
		<markdown @open="open" @save="save" ref="markdown" :input="text_data" @onChange="onChange"></markdown>
	</div>
</template>

<script>
	import markdown from '@/lib/vue-mdEditor/src/components/index.vue'

	export default {
		name: "markdown-component",
		data(){
			return {
				text_data: "",
				html_data: "",
				layout: {
					height: 0,
				},
				save_modal: {
					show: false,
				},
				save_form: {
					title: '',
					tag: '',
					is_public: false,
				},
				hash_markdown: {},
				saveValidate: {
					title: [
						{required: true, message: '请输入代码标题'}
					],
				},
			}
		},
		components: {
			markdown
		},
		methods: {
			resizeWindow(){
				this.layout.height = window.innerHeight - window.layout.header_height - window.layout.footer_height;
			},
			onChange(data){
				this.text_data = data.mdValue;
				this.html_data = data.htmlValue;
			},
			getUserMarkdown(hash){
				this.$fetch.markdown.get_markdown_by_hash({
					hash,
				}).then(data=>{
					this.text_data = data.content;
					this.save_form.title = data.title;
					this.save_form.is_public = data.is_public;
					this.hash_markdown = data;
				})
			},
			open(){
				this.$router.push({name: 'DashboardMarkdown'})
			},
			save(){
				this.OpenSaveModal()
			},
			SaveCode(){
				this.$fetch.markdown.save_markdown_by_hash({
					hash: this.hash_markdown.hash,
					title: this.save_form.title,
					content: this.text_data,
					description: this.save_form.description,
					tag: this.save_form.tag,
					is_public: this.save_form.is_public,
				}).then(data=>{
					this.$Notice.success({
						title: '保存成功',
						desc: '您的文档保存成功',
					});
					this.CloseSaveModal();
				});
			},
			OpenSaveModal(){
				this.save_modal.show = true;
			},
			CloseSaveModal(){
				this.save_modal.show = false;
			}
		},
		watch: {
			text_data(value){
				this.$refs.markdown.setMdValueFn(value);
			}
		},
		mounted(){
			let that = this;
			this.resizeWindow();
			$(window).resize(function(){
				that.resizeWindow();
			});
		},
		created(){
			if(this.$route.params.hash !== undefined){
				this.getUserMarkdown(this.$route.params.hash);
			}else{
				this.text_data = "# Hello Markdown\n## Hello Markdown\n### Hello Markdown\n#### Hello Markdown\n##### Hello Markdown\n";
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../../../src/theme/default.less";
	
	.markdown-component {
		height: calc(100% - @header_height - @footer_height);
		
		.raw {
			height: 100%;
		}
		
		.render {
			img {
				width: 100%;
			}
		}
	}
</style>
